import { ScrollingModule } from '@angular/cdk/scrolling';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import {
	applyValidators,
	DestroyService,
	DialogBase,
	DialogOptions,
	downloadFile,
} from '@marmon/frontend/common';
import {
	ParseInvoiceError,
	ParseInvoiceErrorCsvTemplate,
} from '@marmon/shared/types/analysis';
import { generateCsvAndBlob } from '@marmon/shared/types/common';
import { TuiButton } from '@taiga-ui/core';
import { InvoiceErrorPipe } from '../../pipes';

@Component({
	selector: 'mar-create-analysis-errors-dialog',
	standalone: true,
	imports: [TranslocoPipe, TuiButton, InvoiceErrorPipe, ScrollingModule],
	templateUrl: 'create-analysis-errors-dialog.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [DestroyService],
})
export class CreateAnalysisErrorsDialogComponent extends applyValidators(
	DialogBase<
		void,
		{ errors: ParseInvoiceError[]; fileName: string; confirmText: string }
	>,
) {
	static override DialogOptions = {
		size: 'l',
		header: 'analyses.dialog.create-analysis-errors.header',
		subheader: 'analyses.dialog.create-analysis-errors.subheader',
	} as DialogOptions;

	onDownloadErrors() {
		const csv = generateCsvAndBlob(
			this.context.data.errors.map((e) => {
				// don't expose HTML strings
				delete e.messageHtml;
				return e;
			}),
			ParseInvoiceErrorCsvTemplate,
		);

		downloadFile(csv, `ERRORS_${this.context.data.fileName}.csv`);
	}
}
